<script>
import component from './base.vue';

export default component.extend({
  computed: {
    disableLsp: () => false,
    disableCustomer: () => false,
    disableProofreader: () => false,
    disableQaExpert: () => false,
  },
});
</script>
